<template>
    
<v-card 
      class="d-flex justify-center"
      color=""
      flat
      tile
    >
  <div id="search_element" class="leaflet-control">


   <v-toolbar
    dark
    
  >
    <v-toolbar-title>POI Selection</v-toolbar-title>
    <v-autocomplete
      return-object
      v-on:change="poi_name_selected"
      full-width
      v-model="select"
      :loading="loading"
      :items="my_items"
      :search-input.sync="search"
      cache-items
      class="mx-4"
      flat
      hide-no-data
      hide-details
      label="Start typing the name of the POI for which you want to update its Quiz"
      solo-inverted
    ></v-autocomplete>
  
  </v-toolbar>

</div>
</v-card>



</template>

<script>
    import { componentBus } from '../main';
    import router from '../router';
    import axios from 'axios';
    import {  APIS_BASE_URL } from '../constants';
    export default {
        name: 'SearchPoiToUpdateQuiz',
        data: function () {
            return {

        loading: false,
        my_items: [],
        search: null,
        select: null
        
       


     
    
                
            };
        },

        watch: {
        search (val) {
		val && val !== this.select && this.querySelections(val)
		if(!val) this.get_all_pois();
       }
       },
        computed: {
            
        },
        methods: {
  
        querySelections (v) {
      this.my_items.splice(0,this.my_items.length);
      var poi_search_url=APIS_BASE_URL+"/pois/?title="+v+"&has_quiz=true";
      var poi_search_url_encoded= encodeURI(poi_search_url);
      this.loading = true
   
      axios.get(poi_search_url_encoded)
            .then(response => {
                  response.data.forEach(val => {
                  let object = {
                    text: val.title,
                    value: val.poi_uuid,
                    quiz_uuid: val.relevant_quiz[0].quiz_uuid,
                    relevant_project: val.relevant_project
                  };
            this.my_items.push(object);
            this.loading=false;
                   
            });
                   
             })
            .catch(error => console.log(error)); 
       
          
      },
        
      poi_name_selected: function (event) {
      // `this` inside methods points to the Vue instance
      //alert("malaka");
      console.log("value: "+event.value);
      console.log("text: "+ event.text);
      let payload= {};
      payload["point_uuid"]=event.value;
      payload["relevant_project"]=event.relevant_project;
      componentBus.$emit('render_relevant_pois_and_range_and_focus_on_map', payload);
       if(router.currentRoute.path!="/quiz_edit")
          router.push({ path: '/quiz_edit?quiz_uuid='+event.quiz_uuid+'&project_uuid='+event.relevant_project+'&poi_uuid='+event.value })
      // `event` is the native DOM event
     
    },
        
    get_all_pois() 
	{
      var all_pois_search_url=APIS_BASE_URL+"/pois/?title=&has_quiz=true";
      var all_pois_search_url_encoded= encodeURI(all_pois_search_url);
      this.loading = true
   
      axios.get(all_pois_search_url_encoded)
            .then(response => {
                  response.data.forEach(val => {
                  let object = {
                    text: val.title,
                    value: val.poi_uuid,
                    quiz_uuid: val.relevant_quiz[0].quiz_uuid,
                    relevant_project: val.relevant_project
                  };
            this.my_items.push(object);
            this.loading=false;
                   
            });
                   
             })
            .catch(error => console.log(error)); 
	},
           
        },
        mounted() {
         this.get_all_pois();
    
           
        },
        destroyed() {
           
   
        }
    };
</script>

<style scoped>
#search_element {
 position: fixed;
 bottom: 0;
 margin-bottom: 50px;
 width: 850px;


}
</style>
